const ITEMS = [
    "Real Estate Advisory",
    "Turnkey Interior Design",
    "Bespoke Furniture",
    "Air Conditioning",
    "New Delhi",
];

const MarqueeRow = () => (
    <div className="flex shrink-0 items-center">
        {ITEMS.map((item) => (
            <span key={item} className="flex items-center">
                <span className="px-8 font-serif text-2xl italic tracking-tight text-charcoal/75 sm:px-12 sm:text-3xl">
                    {item}
                </span>
                <span className="h-1.5 w-1.5 rotate-45 bg-bronze" aria-hidden="true" />
            </span>
        ))}
    </div>
);

const Marquee = () => (
    <section
        aria-hidden="true"
        data-testid="editorial-marquee"
        className="overflow-hidden border-b border-bronze/15 bg-cream py-7"
    >
        <div className="marquee-track flex w-max">
            <MarqueeRow />
            <MarqueeRow />
        </div>
    </section>
);

export default Marquee;
